type STRIP_LABELS_TYPE = Record<string, string>;

export const ACCOUNT_STRIP_LABELS = {
    rtsId: 'PB RTS ID',
    sfdcId: 'PB Salesforce ID',
    userIds: 'User IDs',
    accountIds: 'Account IDs',
    accountNames: 'Account Names',
    accountStatuses: 'Account Statuses',
    entityType: 'Entity Type',
    licenseType: 'License Type',
    accountManagerId: 'Account Team Member',
    crmIntegrations: 'CRM Integrations',
};

export const USER_STRIP_LABELS = {
    rtsId: 'PB RTS ID',
    pbSalesforceIds: 'PB Salesforce IDs',
    userIds: 'User IDs',
    accountIds: 'Account IDs',
    firstName: 'First Name',
    lastName: 'Last Name',
    userEmails: 'Emails',
    userTypes: 'User Types',
    userStatuses: 'User Statuses',
    includeInactiveUsers: 'Include Inactive Users',
    accountManagerId: 'Account Team Member',
};


export const STRIP_LABELS: STRIP_LABELS_TYPE = {
    ...ACCOUNT_STRIP_LABELS,
    ...USER_STRIP_LABELS,
};
